import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.382 4.58l-6.59 6.59-2.59-2.58L2.792 10l4 4 8-8-1.41-1.42z" fill="#fff" /></svg>;